import {Controller} from "stimulus"

export default class ProjectsController extends Controller {
  static targets = ["description"];

  connect() {
    if (this.descriptionTarget.value === '') {
      this.descriptionTarget.value = "※ 記入例\n\n" +
          "【依頼内容】\n" +
          "・新規ECサイトのカート機能の開発をお願いできればと思います。\n" +
          "・Ruby on Railsでの開発となります。\n" +
          "\n" +
          "【業務形態】\n" +
          "・毎週1時間程度のMTG以外はリモートでの作業になります。\n" +
          "\n" +
          "【納期・スケジュール】\n" +
          "・2019年10月のリリースを目指しています。\n" +
          "\n" +
          "【参考情報】\n" +
          "・こちらのサイトのようなイメージです。\n" +
          "    https://any-crew.com";
    }
  }
}
